import { Text } from "@hopper-ui/components";
import { WebsiteFavicon } from "#components/ui/WebsiteFavicon.tsx";
import { Channel } from "#features/channels/components/channels-details/Channel.tsx";
import type { GetChannelsDetailsQueryWebsite } from "#types/types.ts";

interface Props {
    website: GetChannelsDetailsQueryWebsite;
}

export const WebsiteItem = ({ website }: Props) => {
    const { friendlyName, rootUrl } = website;

    return (
        <Channel
            icon={<WebsiteFavicon url={rootUrl} />}
            title={friendlyName}
        >
            <Text size="xs" color="neutral-weak">
                {rootUrl}
            </Text>
        </Channel>
    );
};
